import { RESET_PASSWORD } from 'client/redux/resetPassword/constants';
import * as actionCreators from 'client/redux/resetPassword/actionCreators';

export const resetPassword = form => dispatch => {
  return dispatch(actionCreators.resetPassword(RESET_PASSWORD, form));
};
